import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { User } from '../models/user.model';
import { AccountInfo, AuthenticationResult } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class AADAuthenticationService {

  constructor(private authService: MsalService) { 
    this.authService.initialize().subscribe();
  }

  login(resultFunc: (result: AuthenticationResult) => void = null, errorFunc: (error: any) => void = null) {
    const request = {
      scopes: ["user.read"]
    };

    this.authService.ssoSilent(request)
      .subscribe({
        next: (result) => {
          console.log(result)
          if (resultFunc) {
            resultFunc(result);
          }
        },
        error: () => {
          this.authService.loginPopup()
            .subscribe({
              next: (result) => {
                console.log(result);
                if (resultFunc) {
                  resultFunc(result);
                }
              },
              error: (error) => {
                console.log(error);
                if (errorFunc) {
                  errorFunc(error);
                }
              }
            });
        }
      });
  }

  logout(resultFunc: (result: any) => void = null) {
    this.authService.logoutRedirect({
      account: this.getLoggedUser(), 
    })
      .subscribe({
        next: (result) => {
          console.log(result)
          if (resultFunc) {
            resultFunc(result);
          }
        },
        error: (error) => console.log(error)        
      });
  }

  isLoggedIn(): boolean {
    return this.authService.instance.getAllAccounts().length > 0;
  }

  getToken(): string {
    let account = this.getLoggedUser();
    if (account) {
      return account.idToken;
    }
    
    return null;
  }

  getLoggedUser(): AccountInfo {
    let accounts = this.authService.instance.getAllAccounts();
    if (accounts.length > 0) {
      return accounts[0];
    }
    
    return null;
  }

}
